import { Colors } from 'cio-design-library/design-tokens'
import styled from 'styled-components'
import Media from 'builder/styles/media'
import Typography from 'builder/styles/typography'

export const DividerContainer = styled.div`
  display: flex;
  gap: 16px;
  margin: 24px 0px 28px;
`

export const Line = styled.div`
  flex: 1;
  height: 1px;
  background: #e1e5e9;
  margin-top: auto;
  margin-bottom: auto;
`

export const OrText = styled.div`
  text-transform: capitalize;
  font-weight: 400;
  font-size: 16px;
  leading-trim: none;
  line-height: 20px;
  letter-spacing: 0%;
  color: ${Colors.Neutral50};
`

export const Title = styled.div`
  margin-left: auto;
  margin-right: auto;
  ${Typography.XL};
  font-weight: 700;
  color: ${Colors.Blue50};
  margin-bottom: 12px;
  max-width: 555px;
  text-align: center;

  ${Media.Phone`
    text-align: left;
    width: 100%;
  `}
`

export const FieldSuggestion = styled.div`
  ${Typography.Caption};
  cursor: pointer;
`

export const FieldSuggestionText = styled.span`
  color: ${Colors.Neutral50};
  margin-right: 4px;
`

export const FieldSuggestionLink = styled.span`
  display: inline-flex;
  align-items: center;
  color: ${Colors.Blue50};

  & b {
    font-weight: 600;
  }
`

export const RecaptchaContainer = styled.div`
  position: relative;
`

export const Content = styled.div`
  margin-left: auto;
  margin-right: auto;
  width: 100%;
  max-width: 416px;

  ${Media.Phone`
    max-width: 100%;
  `};
`
